// extracted by mini-css-extract-plugin
export default {"modalMessage":"hOjcT7"};